import { DoseRangeDto } from '../../webapi/index';

export class DoseRange {
  constructor(private readonly dto: DoseRangeDto) { }

  get DoseRangeDto() {
    return this.dto;
  }

  get Id() {
    return this.dto.Id;
  }
  get WeightRequired() {
    return this.dto.WeightRequired;
  }
  get BodySurfaceAreaRequired() {
    return this.dto.BodySurfaceAreaRequired;
  }
  get LowDose() {
    return this.dto.LowDose;
  }
  get LowDoseUnits() {
    return this.dto.LowDoseUnits;
  }
  get HighDose() {
    return this.dto.HighDose;
  }
  get HighDoseUnits() {
    return this.dto.HighDoseUnits;
  }
  get MaximumDosePerDay() {
    return this.dto.MaximumDosePerDay;
  }
  get MaximumDosePerDayUnits() {
    return this.dto.MaximumDosePerDayUnits;
  }
  get MaximumSingleDose() {
    return this.dto.MaximumSingleDose;
  }
  get MaximumSingleDoseUnits() {
    return this.dto.MaximumSingleDoseUnits;
  }
  get MaximumLifetimeDose() {
    return this.dto.MaximumLifetimeDose;
  }
  get MaximumLifetimeDoseUnits() {
    return this.dto.MaximumLifetimeDoseUnits;
  }
  get NteAmountPerSingleDose() {
    return this.dto.NteAmountPerSingleDose;
  }
  get NteAmountPerSingleDoseUnits() {
    return this.dto.NteAmountPerSingleDoseUnits;
  }
  get LowFrequency() {
    return this.dto.LowFrequency;
  }
  get HighFrequency() {
    return this.dto.HighFrequency;
  }
  get LowDuration() {
    return this.dto.LowDuration;
  }
  get HighDuration() {
    return this.dto.HighDuration;
  }
  get AdjustedLowDose() {
    return this.dto.AdjustedLowDose;
  }
  get AdjustedHighDose() {
    return this.dto.AdjustedHighDose;
  }
  get AdjustedMaximumSingleDose() {
    return this.dto.AdjustedMaximumSingleDose;
  }
  get AdjustedMaximumDosePerDay() {
    return this.dto.AdjustedMaximumDosePerDay;
  }
  get AdjustedMaximumLifetimeDose() {
    return this.dto.AdjustedMaximumLifetimeDose;
  }
  get AdjustedNteAmountPerSingleDose() {
    return this.dto.AdjustedNteAmountPerSingleDose;
  }
  get RangeLowDose() {
    return this.dto.RangeLowDose;
  }
  get RangeLowDoseUnits() {
    return this.dto.RangeLowDoseUnits;
  }
  get RangeHighDose() {
    return this.dto.RangeHighDose;
  }
  get RangeHighDoseUnits() {
    return this.dto.RangeHighDoseUnits;
  }
  get RangeLowDoseForm() {
    return this.dto.RangeLowDoseForm;
  }
  get RangeLowDoseFormUnits() {
    return this.dto.RangeLowDoseFormUnits;
  }
  get RangeHighDoseForm() {
    return this.dto.RangeHighDoseForm;
  }
  get RangeHighDoseFormUnits() {
    return this.dto.RangeHighDoseFormUnits;
  }
  get NtePediDailyDoseStrength() {
    return this.dto.NtePediDailyDoseStrength;
  }
  get NtePediDailyDoseStrengthUnits() {
    return this.dto.NtePediDailyDoseStrengthUnits;
  }
  get NtePediDailyDoseForm() {
    return this.dto.NtePediDailyDoseForm;
  }
  get NtePediDailyDoseFormUnits() {
    return this.dto.NtePediDailyDoseFormUnits;
  }
  get IngredientStrength() {
    return this.dto.IngredientStrength;
  }
  get IngredientStrengthUomAbbr() {
    return this.dto.IngredientStrengthUomAbbr;
  }
  get IngredientStrengthUomDesc() {
    return this.dto.IngredientStrengthUomDesc;
  }
  get IngredientVolume() {
    return this.dto.IngredientVolume;
  }
  get IngredientVolumeUomAbbr() {
    return this.dto.IngredientVolumeUomAbbr;
  }
  get IngredientVolumeUomDesc() {
    return this.dto.IngredientVolumeUomDesc;
  }
  get WeightKg() {
    return this.dto.WeightKg;
  }
  get BodySurfaceArea() {
    return this.dto.BodySurfaceArea;
  }
  get ErrorMsg() {
    return this.dto.ErrorMsg;
  }
  get HasError() {
    return this.dto.HasError;
  }
}
